var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3512)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_3512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_3512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87502 10.225L12 3.45001L16.125 10.225H7.87502ZM17.5 21.225C16.45 21.225 15.5667 20.8667 14.85 20.15C14.1334 19.4333 13.775 18.55 13.775 17.5C13.775 16.45 14.1334 15.5667 14.85 14.85C15.5667 14.1333 16.45 13.775 17.5 13.775C18.55 13.775 19.4334 14.1333 20.15 14.85C20.8667 15.5667 21.225 16.45 21.225 17.5C21.225 18.55 20.8667 19.4333 20.15 20.15C19.4334 20.8667 18.55 21.225 17.5 21.225ZM3.77502 20.725V14.275H10.225V20.725H3.77502ZM17.5 20.225C18.2667 20.225 18.9127 19.9627 19.438 19.438C19.9627 18.9127 20.225 18.2667 20.225 17.5C20.225 16.7333 19.9627 16.0873 19.438 15.562C18.9127 15.0373 18.2667 14.775 17.5 14.775C16.7334 14.775 16.0874 15.0373 15.562 15.562C15.0374 16.0873 14.775 16.7333 14.775 17.5C14.775 18.2667 15.0374 18.9127 15.562 19.438C16.0874 19.9627 16.7334 20.225 17.5 20.225ZM4.77502 19.725H9.22502V15.275H4.77502V19.725ZM9.62502 9.22501H14.375L12 5.42501L9.62502 9.22501Z",
    fill: "#4B4566"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessProfile);
export default __webpack_public_path__ + "static/media/process-profile.8ecefabe46807d3d68aba497359e57ae.svg";
export { ForwardRef as ReactComponent };